import { fs } from './firebase';

export const fetchPatients = (uid) =>
    fs.collection(`/clients/${uid}/patients/`).orderBy("timestamp", "desc").get()